import React from "react";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

const Drive = () => {
    const navigate = useNavigate();
    return (
        <div >
            <div className="indicator-container">
                <div className="indicator ">

                </div>
                <div className="indicator selected">

                </div>
                <div className="indicator ">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
                <div className="indicator">

                </div>
            </div>


            <div style={{
                marginTop: '2vh',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center'

            }}>
                <img style={{ width: '100%' }} className="vivify driveInLeft" src="/assets/drive.png" alt="dad" />

                <h1 className="large-text"> <CountUp prefix="You Drove Jacoby Around " end={3} duration={2} /> Times</h1>
                <div className="large-button-container">
                    <button onClick={
                        () => {
                            navigate('/steven/bus');
                        }
                    } className="large-button">
                        Let's Continue
                    </button>
                </div>
            </div>

        </div>
    );
}

export default Drive